import { QueryClient, QueryCache, MutationCache } from '@tanstack/react-query';
import { ApiError } from 'shared/api/client.js';

// Customer-accounts task: the account dashboard is this app's first real
// surface with more than one authenticated screen — middleware/
// sessionExpiry.js (security-hardening task) can 401 ANY of its requests
// mid-session, not just the request-form's own single call. Same fix as
// admin/src/queryClient.js's own copy (see that file's header comment for
// the full reasoning): clears the cached session on ANY SESSION_EXPIRED,
// which App.jsx's RequireCustomer guard already redirects to /login on.
function handleQueryError(err) {
  if (err instanceof ApiError && err.code === 'SESSION_EXPIRED') {
    queryClient.setQueryData(['auth', 'me'], null);
  }
}

// portal/CLAUDE.md: this user is "usually on an Android phone, on slow
// mobile data" — a single retry (not react-query's default of 3) so a
// genuinely broken request fails fast into this app's own error state
// instead of quietly retrying for several seconds first.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
  queryCache: new QueryCache({ onError: handleQueryError }),
  mutationCache: new MutationCache({ onError: handleQueryError }),
});
